import type { FaireAdCampaignEntity } from "../../entity_types/adCampaign";

// Emily Lex Studio — Reorder campaign (adc_ba4zkex8h8), running since Mar 2025.
// CAMPAIGN_PERIODS attributes no first-year value to reorder, so sales come from
// TOTAL_LOCAL_POST_DISCOUNT. `monthlyBudgetDollars` is the shared $75,000 pool.
export const campElsReorder: FaireAdCampaignEntity = {
  token: "camp_els_reorder",
  type: "adCampaign",
  advertiserProfileToken: "adv_emily_lex_studio",
  segment: "REORDER_MARKETPLACE",
  status: "RUNNING",
  monthlyBudgetDollars: 75000,
  startedRunningAt: "2025-03-09",
  segmentMetrics: {
    numReorderConversions: 4218,
    salesDollars: 2171049,
    totalAdsSpendDollars: 199049,
    returnOnAdSpend: 10.91,
  },
  performancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-09-23T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
